<template>
  <svg viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.0209 14.5214C20.5896 13.9557 21.5078 13.9537 22.0789 14.5169V14.5169C22.6578 15.0878 22.6598 16.0214 22.0834 16.5948L17.6638 20.9911H31.4911C32.3244 20.9911 33 21.6666 33 22.5V22.5C33 23.3334 32.3244 24.0089 31.4911 24.0089H17.6638L22.0821 28.3967C22.6595 28.9701 22.6589 29.9042 22.0807 30.4769V30.4769C21.509 31.0431 20.5874 31.0422 20.0169 30.4746L12.7127 23.209C12.3197 22.818 12.3197 22.182 12.7127 21.791L20.0209 14.5214Z"
      fill="white"
    />
  </svg>
</template>
